<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <svg class="custom_icon" version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000"
    preserveAspectRatio="xMidYMid meet">

    <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)">
    <path d="M0 357 l0 -283 86 -36 86 -37 69 34 c38 19 74 35 80 35 6 0 47 -16
    91 -35 l79 -34 75 37 74 36 0 283 0 283 -74 -37 -74 -37 -87 37 -86 36 -74
    -36 -73 -37 -86 37 -86 36 0 -282z m494 163 c9 0 35 9 56 20 l40 20 0 -228 0
    -228 -45 -22 c-58 -28 -60 -28 -140 8 -37 16 -74 30 -83 30 -10 0 -46 -14 -80
    -30 -35 -17 -69 -30 -75 -30 -6 0 -35 10 -64 22 l-53 22 0 229 c0 214 1 229
    18 224 9 -3 38 -14 64 -24 l47 -18 73 36 72 36 77 -34 c42 -18 84 -33 93 -33z"/>
    <path d="M243 504 c-10 -28 13 -37 25 -9 10 21 9 25 -4 25 -8 0 -17 -7 -21
    -16z"/>
    <path d="M308 486 c-10 -7 -15 -15 -13 -18 3 -3 -1 -11 -10 -18 -20 -16 -20
    -60 0 -60 8 0 15 9 15 19 0 31 54 23 58 -8 3 -17 0 -22 -10 -19 -17 7 -53 -22
    -62 -50 -10 -30 9 -61 33 -55 23 6 42 -43 38 -99 -1 -20 2 -38 6 -40 7 -3 50
    103 64 160 12 48 39 5 29 -46 -3 -15 -2 -34 4 -42 8 -12 10 -10 10 11 0 14 7
    34 15 45 13 16 16 17 24 4 9 -12 15 -9 40 20 35 41 39 70 11 77 -26 7 -27 49
    -1 65 16 10 18 16 9 32 -6 12 -12 23 -14 25 -2 2 -22 -11 -44 -29 -39 -31 -41
    -32 -47 -12 -3 11 -12 23 -20 26 -8 4 -11 11 -7 18 5 9 2 8 -9 -1 -14 -11 -23
    -12 -43 -2 -32 14 -55 14 -76 -3z"/>
    <path d="M83 483 c-22 -8 -15 -32 7 -26 23 6 24 1 8 -43 -11 -30 -9 -35 13
    -57 13 -13 32 -26 42 -30 23 -9 22 -34 -3 -49 -19 -12 -28 -38 -12 -38 10 0
    42 -75 42 -99 0 -10 7 -24 15 -31 12 -10 15 -9 15 6 0 30 24 89 43 108 32 33
    14 67 -46 86 -26 8 -41 20 -48 37 -13 35 -2 43 20 14 l18 -24 16 24 c11 17 14
    39 10 77 -5 51 -17 64 -40 41 -8 -8 -13 -8 -17 0 -7 11 -60 14 -83 4z"/>
    <path d="M521 195 c-28 -35 -17 -80 14 -55 8 6 19 9 25 5 6 -4 10 7 10 27 0
    27 -4 34 -21 34 -11 0 -24 -5 -28 -11z"/>
    </g>
    </svg>
</template>

<script>
    export default {
        name: 'WorldMap'
    }
</script>

<style>
    .custom_icon {
        fill: currentColor;
        stroke: currentColor;
    }
</style>